<div class="analisis-productos">
    <header class="analisis-header">
        <h2>Análisis de productos</h2>
        <div class="botones-tabs">
            <button
                type="button"
                class="btn-tab"
                *ngFor="let tipo of tiposProductoTab"
                [class.active]="activeTipoProductoId === tipo.id"
                (click)="cambiarTab(tipo.id)">
                {{ tipo.nombre }}
            </button>
        </div>
    </header>

    <app-table
        [data]="data"
        [columns]="columns"
        [filters]="filters"
        [editFilter]="true"
        [styleFilters]="'col-md-3'"
        [total]="total"
        [page]="pagina"
        [showCheckboxes]="true"
        [pageSize]="tamanoPagina"
        [textoRegistros]="'productos'"
        [textoMostrar]="'Mostrar'"
        [mostrarBotonLimpiar]="true"
        [mostrarBotonAplicar]="false"
        [mostrarBotonEditar]="true"
        (filtersChange)="onFiltersUpdate($event)">
    </app-table>
</div>
